import { styled } from '@mui/material/styles';

const PREFIX = 'Root';
const classes = {
    container: `${PREFIX}-container`,
    global: `@global`
}

const Root = styled('main')(({ theme }) => ({
    [`&.${classes.container}`]: {
        padding: '1rem',
        '& a': {
            textDecoration: 'none'
        },
        // Typography styles moved to theme
        // Remove manual font size overrides as they're now in theme
    }, [`&.${classes.global}`]: {
        a: {
            color: '#0000ff',
        },
        '& a:hover': {
            textDecoration: 'underline'
        }
    },
}));

export { classes, Root };
